module.exports = __webpack_public_path__ + "static/media/Skyfarm Drive, Santa Rosa, CA1.7961ad07.jpg";